import {
  TEntityResponse,
  TEntityListResponse,
  TDeviceProfileMetricResBody,
  TDeviceProfileMetricSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TDeviceProfileMetricsClient = {
  get(id: string): Promise<TEntityResponse<'device-profile-metric', TDeviceProfileMetricResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'device-profile-metric', TDeviceProfileMetricSummaryResBody> | undefined>;
};

function DeviceProfileMetricsClient(apiClient: TAPIClient): TDeviceProfileMetricsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'device-profile-metric', TDeviceProfileMetricResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'device-profile-metric', TDeviceProfileMetricResBody>>(
        `/device-profile-metrics/${id}`
      );

      if (data && data.type !== 'device-profile-metric') {
        throw new Error('Invalid entity type received, expected: device-profile-metric, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'device-profile-metric', TDeviceProfileMetricSummaryResBody> | undefined> {
      const data = await apiClient.get<
        TEntityListResponse<'device-profile-metric', TDeviceProfileMetricSummaryResBody>
      >(`/device-profile-metrics?limit=${limit}&page=${page}`);

      if (data && data.type !== 'device-profile-metric') {
        throw new Error('Invalid entity type received, expected: device-profile-metric, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TDeviceProfileMetricsClient, DeviceProfileMetricsClient };
